import swal from "sweetalert";
import {
  CREATE_AFFIARS_OF_SURGERY_FAIL,
  CREATE_AFFIARS_OF_SURGERY_REQUEST,
  CREATE_AFFIARS_OF_SURGERY_SUCCESS,
  UPDATE_AFFIARS_OF_SURGERY_FAIL,
  UPDATE_AFFIARS_OF_SURGERY_REQUEST,
  UPDATE_AFFIARS_OF_SURGERY_SUCCESS,
} from "../../ActionType/AffiarsOfSurgeryTypes/AffiarsOfSurgeryTypes";
import { api } from "../../Api/api";
import { getToken } from "../login";

import { getVisitAction } from "../VisitAction/VisitAction";

export const createAffirasOfSurgeryAction =
  (type, note, visit_id, patientId) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };

    dispatch({
      type: CREATE_AFFIARS_OF_SURGERY_REQUEST,
      payload: [],
    });
    try {
      const response = await api.post(
        "affiarsOfSurgery/create",
        { type, note, visit_id },
        config
      );
      const { status, data } = response;

      if (status == 201) {
        dispatch(getVisitAction(patientId))
        dispatch(getVisitAction(patientId))
        swal({
          title: "Good job!",
          text: "Affiars Of Surgery  was saved Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
        dispatch({
          type: CREATE_AFFIARS_OF_SURGERY_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {

      dispatch({
        type: CREATE_AFFIARS_OF_SURGERY_FAIL,
        payload: [],
      });
    }
  };

export const updateAffirasOfSurgeryAction =
  (id, type, note, visit_id, patientId) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    
    dispatch({
      type: UPDATE_AFFIARS_OF_SURGERY_REQUEST,
      payload: [],
    });
    try {
      const response = await api.post(
        "affiarsOfSurgery/update",
        { id, type, note, visit_id },
        config
      );
      const { status, data } = response;
        // console.log(response)
      if (status == 200) {
        dispatch(getVisitAction(patientId))
        dispatch(getVisitAction(patientId))
        swal({
          title: "Good job!",
          text: "Affiars Of Surgery  was Updated Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
        dispatch({
          type: UPDATE_AFFIARS_OF_SURGERY_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: UPDATE_AFFIARS_OF_SURGERY_FAIL,
        payload: [],
      });
    }
  };
